import { Box, Container, Divider, Grid, MenuItem, Paper, Typography } from "@mui/material";
import { ButtonBase, CheckboxBase, FormControlBase, FormSectionBox, FormSectionTitle, InputLabelSelect, SelectBase, TextFieldBase } from "../../styles";
import { FormikProvider, useFormik } from "formik";
import * as Yup from 'yup';
import { useContext, useEffect } from "react";
import { format, subDays } from "date-fns";
import { MyContext } from "../../../../Context/MyContext";
import { PedidosContext } from "../../../../Context/PedidosContext";
import api from "../../../../Api/apiAxios";


export function ModalCancelamento({ pedido }) {
  const idUsuario = window.localStorage.getItem('idUsuario');
  
  const { setMensagemGlobal, setTipoMensagemGlobal } = useContext(MyContext);
  const { setIsLoading } = useContext(PedidosContext);

  const { 
    fetchPedidosFolha, 
    fetchPedidosPonto, 
    setModalCancelamento, 
    productVariant, 
    motivosCancelamento, 
    fetchMotivosCancelamento,
  } = useContext(PedidosContext);

  const handleCancel = async (values) => {
    try {
      setIsLoading(true);

      const resp = await api.put(`/Bma${productVariant}/atualizar-status-pedido?id=${pedido.id}&status=2&motivo=${formik.values.motivoCancelamento}&motivoCancelamentoOpcao=${formik.values.motivoCancelamentoOpcao}&dataCancelamento=${formik.values.dataCancelamento}&usuarioId=${idUsuario}`);
      
      productVariant === 'Folha' ? fetchPedidosFolha() : fetchPedidosPonto();

      if (resp.data.id > 0) {
        setMensagemGlobal('Pedido atualizado com sucesso!');
        setTipoMensagemGlobal("success");
      } else {
        setMensagemGlobal('Ocorreu um erro ao atualizar o pedido.');
        setTipoMensagemGlobal("danger");
      }  
    } catch (e) {
      console.log(e)
    } finally {
      setModalCancelamento({show: false, pedido: {}});
      setIsLoading(false);
    }               
  }

  const validationSchema = Yup.object({
    tipoPedido: Yup.number().nullable(),
    cliente: Yup.string().nullable(),
    numeroInscricao: Yup.string().nullable(),
    dataPedido: Yup.date().nullable(),
    totalPedido: Yup.number(),
    valorMensal: Yup.number(),
    tipoPlano: Yup.number().nullable(),
    bancoDeDados: Yup.number().nullable(),
    versao: Yup.number(),
    release: Yup.number(),
    faixaFuncionarios: Yup.number(),
    contrato: Yup.boolean(),
    dataCancelamento: Yup.date().required('Data do cancelamento deve ser selecionada.').min(subDays(new Date(), 1), 'A data de cancelamento não pode ser anterior à data atual'),
    motivoCancelamentoOpcao: Yup.number().required('Motivo do cancelamento deve ser selecionado.'),
    motivoCancelamento: Yup.string()
    .nullable(),
  });

  const dataDeCancelamento = pedido.dataCancelamento !== null ? format(new Date(pedido.dataCancelamento), 'yyyy-MM-dd') : format(new Date(), 'yyyy-MM-dd')

  const formik = useFormik({
    initialValues: {
      tipoPedido: pedido.tipoPedido,
      cliente: pedido.cliente.nomeFantasia,
      numeroInscricao: pedido.cliente.numeroInscricao,
      dataPedido: format(new Date(pedido.dataPedido), 'yyyy-MM-dd'),
      totalPedido: pedido.valorBruto,
      valorMensal: pedido.valorMensal,
      tipoPlano: pedido.tipoInstalacao,
      bancoDeDados: pedido.tipoBancoDados,
      versao: pedido.versaoSistema,
      release: pedido.versaoRelease,
      faixaFuncionarios: pedido.faixaFuncionarios,
      contrato: pedido.contrato,
      dataCancelamento: dataDeCancelamento,
      motivoCancelamentoOpcao: pedido.motivoCancelamentoOpcao || 0,
      motivoCancelamento: pedido.motivoCancelamento || '',
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      handleCancel(values);
    },
  });

  useEffect(() => {
    fetchMotivosCancelamento();
  }, [])

  return (
    <Container sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
      <Paper sx={{ 
          p: 2, 
          width: '80%', 
          alignSelf: 'center', 
          position: 'fixed', 
          top: 80, 
          overflow: 'auto', 
          zIndex: 1000, 
          maxHeight: '80vh',
          backgroundColor: '#f8f9fa',
        }}  
        elevation={3}
      >
        <Typography variant="h5" sx={{ pb: 1, color: 'tomato', fontWeight: 'bold', width: '100%', textAlign: 'center' }}>
          Cancelar Pedido
        </Typography>

        <Divider />

        <Box
          component='form'
          onSubmit={formik.handleSubmit}
          sx={{ p: 1, mt: 1, display: 'flex', flexDirection: 'column', gap: 2 }}
        >
          <FormSectionBox>
            <FormSectionTitle label='Dados do Pedido' />
              <Grid container spacing={2} sx={{ pb: 2, px: 4, mt: 1, display: 'flex' }}>
                <Grid item xs={4}>
                  <FormControlBase>
                    <InputLabelSelect id="tipoPedido">Tipo de Pedido</InputLabelSelect>
                    <SelectBase 
                      id="tipoPedido"
                      name="tipoPedido"
                      label='Tipo de Pedido'
                      value={formik.values.tipoPedido}
                      isShow={true}
                      width='100%'
                    >
                      <MenuItem value={0}>Licença Nova</MenuItem>
                      <MenuItem value={1}>Atualização</MenuItem>
                    </SelectBase>
                  </FormControlBase>
                </Grid>
                <Grid item xs={4}>
                  <FormControlBase>
                    <InputLabelSelect id="cliente">Cliente</InputLabelSelect>
                    <TextFieldBase 
                      id="cliente" 
                      label="Cliente"
                      name="cliente"
                      value={formik.values.cliente}
                      disabled
                      width='100%'
                    />
                  </FormControlBase>
                </Grid>
                <Grid item xs={4}>
                  <FormControlBase>
                    <InputLabelSelect id="numeroInscricao">CNPJ / CPF</InputLabelSelect>
                    <TextFieldBase 
                      id="numeroInscricao" 
                      label="CNPJ / CPF"
                      name="numeroInscricao"
                      value={formik.values.numeroInscricao}
                      disabled
                      width='100%'
                    />
                  </FormControlBase>
                </Grid>
                <Grid item xs={4}>
                <FormControlBase>
                    <TextFieldBase 
                      label="Data do Pedido" 
                      name="dataPedido"
                      value={formik.values.dataPedido}
                      type="date"
                      width='100%'
                      disabled={true}
                    />
                  </FormControlBase>
                </Grid>
                <Grid item xs={4}>
                  <FormControlBase>
                    <TextFieldBase 
                      label="Total Pedido (R$)"
                      name="totalPedido"
                      value={formik.values.totalPedido} 
                      disabled
                      width='100%'
                    />
                  </FormControlBase>
                </Grid>
                <Grid item xs={4}>
                  <FormControlBase>
                    <TextFieldBase 
                      label="Valor Mensal (R$)"
                      name="valorMensal"
                      value={formik.values.valorMensal} 
                      disabled 
                      width='100%'
                    />
                  </FormControlBase>
                </Grid>
              </Grid>
          </FormSectionBox>

          <FormSectionBox>
            <FormSectionTitle label='Dados da Licença' />
            <Grid container spacing={2} sx={{ pb: 2, px: 4, mt: 1, display: 'flex' }}>
              <Grid item xs={6}>
                <FormControlBase>
                  <InputLabelSelect id="bancoDeDados">Banco de Dados</InputLabelSelect>
                  <SelectBase 
                    id="bancoDeDados" 
                    label="Banco de Dados"
                    name="bancoDeDados"
                    value={formik.values.bancoDeDados}
                    isShow={true}
                    width='100%'
                  >
                    <MenuItem value={1}>MySql</MenuItem>
                    <MenuItem value={2}>SqlServer</MenuItem>
                    <MenuItem value={3}>Oracle</MenuItem>
                  </SelectBase>
                </FormControlBase>
              </Grid>
              <Grid item xs={6}>
                <FormControlBase>
                  <InputLabelSelect  id="tipoPlano">Plano</InputLabelSelect>
                  <SelectBase 
                    id="tipoPlano" 
                    label="Plano"
                    name="tipoPlano"
                    value={formik.values.tipoPlano}
                    width='100%'
                    isShow={true}
                  >
                    <MenuItem value={0}>Licenciado</MenuItem>
                    <MenuItem value={1}>SaaS (Rep - C)</MenuItem>
                    <MenuItem value={2}>SaaS (Rep - P)</MenuItem>
                  </SelectBase>
                </FormControlBase>
              </Grid>
              <Grid item xs={6}>
                <FormControlBase>
                  <TextFieldBase 
                    id="versao"
                    name="versao"
                    label="Versão"
                    value={`${formik.values.versao.toString().includes('.') ? formik.values.versao : (formik.values.versao.toString().substring(1).length > 0 ? `${formik.values.versao.toString().substring(0,1)}.${formik.values.versao.toString().substring(1)}` : formik.values.versao)}.${formik.values.release}`}
                    width='100%'
                    disabled 
                  />
                </FormControlBase>
              </Grid>
              <Grid item xs={6}>
                <FormControlBase>
                  <TextFieldBase 
                    label="Faixa de Funcionários"
                    name="faixaFuncionarios"
                    value={formik.values.faixaFuncionarios}
                    width='100%'
                    disabled={true}
                  />
                </FormControlBase>
              </Grid>
            </Grid>

            <FormikProvider value={formik}>
              <Grid container spacing={2} sx={{ pb: 2, px: 4, mt: 1, display: 'flex' }}>
                <Grid item xs={3}>
                  <CheckboxBase
                    name="contrato"
                    checked={formik.values.contrato}
                    disabled
                    label="Contrato"
                  /> 
                </Grid>
              </Grid>
            </FormikProvider>
          </FormSectionBox>

          <FormSectionBox>
            <FormSectionTitle label='Dados do Cancelamento' />
            <Grid container spacing={2} sx={{ pb: 2, px: 4, mt: 1, display: 'flex' }}>
              <Grid item xs={4}>
                <FormControlBase>
                  <TextFieldBase 
                    label="Data de Cancelamento" 
                    name="dataCancelamento"
                    value={formik.values.dataCancelamento}
                    type="date"
                    onChange={formik.handleChange}
                    onBlur={formik.onBlur}
                    error={formik.touched.dataCancelamento && Boolean(formik.errors.dataCancelamento)}
                    helperText={formik.touched.dataCancelamento && formik.errors.dataCancelamento}
                    width='100%'
                  />
                </FormControlBase>
              </Grid>
              <Grid item xs={8}>
                <FormControlBase>
                  <InputLabelSelect  id="motivoCancelamentoOpcao">Motivo</InputLabelSelect>
                  <SelectBase 
                    id='motivoCancelamentoOpcao'
                    name='motivoCancelamentoOpcao'
                    value={formik.values.motivoCancelamentoOpcao}
                    onChange={formik.handleChange}
                    error={formik.touched.motivoCancelamentoOpcao && Boolean(formik.errors.motivoCancelamentoOpcao)}
                    helperText={formik.touched.motivoCancelamentoOpcao && formik.errors.motivoCancelamentoOpcao}
                    label='Motivo'
                    width='100%'
                  >
                    {motivosCancelamento.map((motivo) => (
                      <MenuItem key={motivo.id} value={motivo.id}>
                        {motivo.descricaoMotivo}
                      </MenuItem>
                    ))}
                  </SelectBase>
                </FormControlBase>
              </Grid>

              <Grid item xs={12}>
                <FormControlBase>
                  <TextFieldBase 
                    label="Detalhes"
                    name="motivoCancelamento"
                    value={formik.values.motivoCancelamento}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.motivoCancelamento && Boolean(formik.errors.motivoCancelamento)}
                    helperText={formik.touched.motivoCancelamento && formik.errors.motivoCancelamento}
                    width='100%'  
                    multiline 
                    rows={4}
                  />
                </FormControlBase>
              </Grid>
            </Grid>
          </FormSectionBox>
          
          <Divider />

          <Box sx={{ display: 'flex', justifyContent: 'center', gap: 0.5, pt: 2}}>
            <ButtonBase variant="outlined" onClick={() => setModalCancelamento({show: false, pedido: {}})}>
              Voltar
            </ButtonBase>

            <ButtonBase type="submit" variant="contained">
              Cancelar
            </ButtonBase>
          </Box>
        </Box>
      </Paper>
    </Container>
  )
}
